/**
 * First-touch attribution
 * Stores the external referrer and landing URL once per session so enquiry
 * forms can report where the visitor originally came from.
 */

const KEY = 'oe_attr';

export function initAttribution() {
    try {
        if (sessionStorage.getItem(KEY)) {
            return;
        }

        let referrer = document.referrer || '';
        if (referrer) {
            try {
                if (new URL(referrer).host === location.host) {
                    referrer = '';
                }
            } catch (e) {
                referrer = '';
            }
        }

        sessionStorage.setItem(KEY, JSON.stringify({
            referrer,
            landing: location.pathname + location.search,
            ts: Date.now(),
        }));
    } catch (e) {}
}

export function getAttribution() {
    try {
        const data = JSON.parse(sessionStorage.getItem(KEY) || '{}');
        return {
            referrer: typeof data.referrer === 'string' ? data.referrer : '',
            landing: typeof data.landing === 'string' ? data.landing : '',
        };
    } catch (e) {
        return { referrer: '', landing: '' };
    }
}
